import React from "react";
import styles from "./Footer.module.scss";
import {SVGFacebook, SVGInstagram, SVGAdiona} from "../assets/PackageSVG";

export const Footer = ()=> {
    return (
        <footer className={styles.Footer}>
            <div className={styles.divFooter}>
                <div className={styles.divFooterTopSection}>
                    <div>
                        <div className={styles.logoContainer}>
                            <SVGAdiona />
                            {/*<div className={styles.logoBox}>*/}
                            {/*    <span className={styles.logoLetter}>M</span>*/}
                            {/*</div>*/}
                            <span className={styles.logoText}>Adiona Travel</span>
                        </div>
                        <p className={styles.pFooter}>
                            Transforming travel planning with AI-powered personalization and smart budget management.
                        </p>
                        <div className={styles.divMediaLinks}>
                            <a href="#" className="text-gray-400 hover:text-white transition-colors">
                                <SVGInstagram width="24" height="24" />
                            </a>
                            <a href="#" className="text-gray-400 hover:text-white transition-colors">
                                <SVGFacebook width="24" height="24" />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className={styles.h4}>Product</h4>
                        <ul className={styles.ul}>
                            <li><a href="#" className={styles.ulLiA}>Features</a></li>
                            <li><a href="#" className={styles.ulLiA}>Pricing</a></li>
                            <li><a href="#" className={styles.ulLiA}>API</a></li>
                            <li><a href="#" className={styles.ulLiA}>Integrations</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className={styles.h4}>Company</h4>
                        <ul className={styles.ul}>
                            <li><a href="#" className={styles.ulLiA}>About</a></li>
                            <li><a href="#" className={styles.ulLiA}>Blog</a></li>
                            <li><a href="#" className={styles.ulLiA}>Careers</a></li>
                            <li><a href="#" className={styles.ulLiA}>Press</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className={styles.h4}>Support</h4>
                        <ul className={styles.ul}>
                            <li><a href="#" className={styles.ulLiA}>Help Center</a></li>
                            <li><a href="#" className={styles.ulLiA}>Contact</a></li>
                            <li><a href="#" className={styles.ulLiA}>Privacy</a></li>
                            <li><a href="#" className={styles.ulLiA}>Terms</a></li>
                        </ul>
                    </div>
                </div>

                <div className={styles.divCopyRight}>
                    <p>© 2024 Adiona Travel. All rights reserved. Transforming travel planning with AI.</p>
                </div>
            </div>
        </footer>
    )
}